import React, {Component} from 'react';
import PieChart from 'react-minimal-pie-chart';

class VideoQuestionSummary extends Component {

    renderVideoQuestionAnswer = () => {
        
        return this.props.fullQuestions.map((fquestion, index) => {
            let question = this.props.videoQuestions.filter(v => v.videoQuestionId === fquestion.id);
            if(question.length > 0){
                question = question[0];
                
                return (
                    <tr key={index}>
                <td className="">
                    <i className={
                        question.correct
                            ? "zmdi zmdi-check text-success font-24"
                            : "zmdi zmdi-close text-danger font-24"
                    }
                    />
                </td>
                <td>
                    <p className="font-14" dangerouslySetInnerHTML={{__html: question.text}}>
                    </p>
                </td>
                <td className="">
                    <span className={
                        !question.correct
                            ? 
                             "text-danger font-18"
                            :     question.attempts > 1 ?
                                    "text-danger font-18"
                                : "text-success font-18"
                    }>
                        {question.attempts}
                    </span>
                </td>
            </tr>
                    )
            }else{
                return null
                    
            }
        });
    };

    render() {

        let totalQuestions = (this.props.fullQuestions) ? this.props.fullQuestions.length : 0;
        let correctAnswers = [];//this.props.videoQuestions.filter(q => q.correct == true).length;


        // filter out duplicates:
        this.props.fullQuestions.map(v => {
            let existing = this.props.videoQuestions.filter(q => q.videoQuestionId === v.id);
            
            if(existing.length > 0){
                if(existing[0].correct){
                    correctAnswers.push(existing[0]);
                }
            }
            return true;
        });
        
        

        
        let correctPercent = Math.ceil(correctAnswers.filter(c => c.attempts === 1).length / totalQuestions * 100);
        correctPercent = (correctPercent > 100) ? 100 : correctPercent;
        return (
            <div className="tab-pane active" id="video_question_summary">
                <div className="sp-20">
                    <div className="pull-right">
                        <div className="video-question-summary">
                            <PieChart
                                style={{width: 50, margin: '0 auto'}}
                                data={[
                                    {value: 100, color: '#555'},
                                    {value: correctPercent, color: '#e33339'}
                                ]}
                                totalValue={100}
                                startAngle={-90}
                                lineWidth={10}
                                rounded={true}
                            />
                            <p className="diagnostic-pie-chart-counter">{correctPercent}%</p>
                        </div>
                    </div>
                    <p className="font-24 text-white">
                        You answered {correctAnswers.filter(c => c.attempts === 1).length} out of {totalQuestions} questions correctly on your first attempt.
                        </p>
                    <table className="table">
                        <tbody>
                        <tr>
                            <th>Result</th>
                            <th>Question</th>
                            <th>Attempts</th>
                        </tr>

                        {this.renderVideoQuestionAnswer()}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

export default VideoQuestionSummary;


// WEBPACK FOOTER //
// ./src/components/Video/VideoQuestionSummary.js